<template>
    <TemplatesSitesSingle :pathId="pathId" />
</template>

<script setup>
    const route = useRoute();
    const pathId = route.params.site[0];
</script>
